export default __webpack_public_path__ + "static/ready-set-relax-8-ways-you-can-actually-relax-on-holiday-activities-b1527604f39e1a39205411455542fff4.jpg";